<template>
  <div v-if="visibleCareServices.length > 0" class="care-services-container">
    <div class="care-services-grid">
      <CareTypeCard
        v-for="careType in visibleCareServices"
        :key="careType"
        :care-type="careType"
        class="m-8 w-160 md-2:w-240 lg:w-160"
        :show-arrow="false"
        :selected="false"
        :style="{ '--dynamic-clickable-hover': '1' }"
        @select="navigateToCareTypeProfile"
      />
    </div>
  </div>
</template>

<script lang="ts">
import CareTypeCard from '@/components/careType/CareTypeCard.vue';
import { getProviderProfilePreservedQuery } from '@/helpers/providerProfileUrl';
import { sendSegmentEvent } from '@/lib/segment';

export default {
  name: 'ProfileCareServicesOffered',
  components: {
    CareTypeCard,
  },
  props: {
    visibleCareServices: {
      type: Array as () => string[],
      required: true,
    },
    sitterUuid: {
      type: String,
      required: true,
    },
    accountTypeInfo: {
      default: () => ({}),
      type: Object,
    },
  },
  methods: {
    trackCareServiceClicked(careType: string): void {
      const { isParent } = this.accountTypeInfo;

      if (isParent) {
        sendSegmentEvent('Additional Service Offered Clicked', {
          sitter_uuid: this.sitterUuid,
          care_type: this.$route.params.care_type,
          clicked_care_type: careType.toLowerCase(),
        });
      } else {
        sendSegmentEvent('Profile Care Services Offered Clicked', {
          care_type: this.$route.params.care_type,
          clicked_care_type: careType.toLowerCase(),
        });
      }
    },
    navigateToCareTypeProfile(careType: string): void {
      this.trackCareServiceClicked(careType);
      this.$router.push({
        path: `/provider/profile/${careType.toLowerCase()}/${this.sitterUuid}`,
        query: getProviderProfilePreservedQuery(this.$route),
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.care-services-container {
  width: 100%;
}

.care-services-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  width: 100%;

  @media (max-width: 380px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}
</style>
